import styled from "styled-components";

export const Content = styled.div`
  width: 70%;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;

  background: #ffffff;

  margin: 0 auto;

  > p {
    font-size: 20px;
    font-weight: bold;

    margin: 36px 0;

    text-align: center;
  }
`;

export const ButtonsContainer = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfirmButton = styled.button`
  background: #00BF33;

  font-weight: 500;

  color: #FFFFFF;

  border: "0";

  padding: 8px 0;

  width: 45%;
`;

export const CancelButton = styled.button`
  background: #bf0000;

  font-weight: 500;

  color: #ffffff;

  padding: 8px 0;

  width: 45%;

  margin-left: 16px;
`;
